<template>
  <div
    class="d-flex flex-column card"
    :class="
      item.url_midia_colaboracao && !isFullScreen ? 'mb-10' : !isFullScreen ? 'mb-10' : ''
    "
    :style="cardStyle"
    :key="item.id_colaboracao"
  >
    <section class="d-flex align-center flex-grow-1">
      <template v-if="hasLoadedProperties">
        <div
          class="d-flex align-end"
          :class="renderMode === 'text' ? 'align-center justify-center' : ''"
          :style="
            renderMode === 'midia' && midiaOrientation === 'vertical'
              ? { width: '100%', justifyContent: 'center' }
              : ''
          "
        >
          <div
            v-if="
              renderMode === 'midia_texto' &&
              midiaOrientation &&
              midiaOrientation === 'vertical'
            "
            class="borda"
          >
            <div
              class=""
              style="background-color: rgb(56, 25, 115); z-index: 1"
              :id="`${item.id_colaboracao}-midia-wrapper`"
            >
              <img
                v-if="item.dsc_tipo_midia_colaboracao === 'image'"
                :id="`${item.id_colaboracao}`"
                :src="item.url_midia_colaboracao"
                :style="
                  isFullScreen
                    ? `max-width: ${
                        (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) /
                        100
                      }px;
                                                            min-width: ${
                                                              (percentScreenDim.fullScreenMinWidth *
                                                                screenDimensions.width) /
                                                              100
                                                            }px;
                                                            max-height: ${
                                                              (percentScreenDim.fullScreenMaxHeight *
                                                                screenDimensions.height) /
                                                              100
                                                            }px;
                                                            min-height: ${
                                                              (percentScreenDim.fullScreenMinHeight *
                                                                screenDimensions.height) /
                                                              100
                                                            }px;`
                    : `max-width: ${
                        (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                      }px;
                                                            max-height: ${
                                                              (percentScreenDim.maxHeight *
                                                                screenDimensions.height) /
                                                                100 -
                                                              50
                                                            }px`
                "
              />
              <video
                v-else-if="item.dsc_tipo_midia_colaboracao === 'video'"
                autoplay
                :id="`${item.id_colaboracao}`"
                :key="item.url_midia_colaboracao"
                style="justify-self: center; z-index: 10000 !important"
                :style="
                  isFullScreen
                    ? `max-height: ${
                        (percentScreenDim.fullScreenMaxHeight * screenDimensions.height) /
                        100
                      }px;
                                                            max-width: ${
                                                              (percentScreenDim.fullScreenMaxWidth *
                                                                screenDimensions.width) /
                                                              100
                                                            }px`
                    : `max-height: ${
                        (percentScreenDim.maxHeight * screenDimensions.height) / 100 - 50
                      }px`
                "
              >
                <source :src="item.url_midia_colaboracao" />
              </video>
            </div>
          </div>
          <div
            :class="
              renderMode === 'midia_texto' &&
              midiaOrientation &&
              midiaOrientation === 'vertical'
                ? 'borda-vertical'
                : 'borda'
            "
            :style="
              renderMode === 'midia_texto' &&
              midiaOrientation &&
              midiaOrientation === 'vertical'
                ? 'margin-left: -2px;'
                : ''
            "
          >
            <header
              v-if="
                !hideUserInfo &&
                !(
                  item.url_midia_colaboracao &&
                  item.dsc_texto_colaboracao &&
                  item.flg_exibir_texto &&
                  midiaOrientation === 'vertical' &&
                  !isFullScreen
                )
              "
              class="d-flex flex-wrap-1 px-2 mt-n4"
              style="position: relative; z-index: 200000"
            >
              <div class="d-flex align-center">
                <span
                  class="text-uppercase mx-2 ml-8 py-1"
                  :class="isFullScreen ? 'text-h4' : ''"
                  style="
                    color: rgb(255, 255, 255) !important;
                    font-size: 1.3rem;
                    text-shadow: 2px 3px 12px rgba(0, 0, 0, 0.95);
                    font-family: 'Gobold Thin';
                  "
                >
                  <template v-if="flgExibirUf && item.dsc_uf_colaborador">
                    {{ `${item.dsc_nome_colaborador} - ${item.dsc_uf_colaborador}` }}
                  </template>
                  <template v-else>
                    {{ item.dsc_nome_colaborador }}
                  </template>
                </span>
              </div>
            </header>
            <div
              v-if="renderMode === 'text'"
              v-html="item.dsc_texto_colaboracao"
              class="font-weight-normal text-uppercase fundo-com-background pa-2"
              style="color: rgb(255, 255, 255); font-family: 'Gobold Thin'"
              :style="{
                lineHeight: lineHeight,
                fontSize: bodyTextSize,
                wordBreak: 'break-word',
              }"
            ></div>

            <div
              v-if="renderMode === 'texto_fullscreen'"
              v-html="item.dsc_texto_colaboracao"
              class="px-3 py-3 font-weight-normal text-uppercase fundo-com-background"
              style="color: rgb(255, 255, 255); font-family: 'Gobold Thin'"
              :style="{
                lineHeight: lineHeightFullScreen,
                fontSize: bodyTextSizeFullSreen,
                wordBreak: 'break-word',
              }"
            ></div>

            <div
              v-else-if="renderMode === 'audio'"
              class="d-flex align-center align-self-center justify-center px-8 py-2 fundo-com-background"
            >
              <audio
                controls
                controlslist="nodownload"
                autoplay
                style=""
                :key="item.url_midia_colaboracao"
              >
                <source :src="item.url_midia_colaboracao" />
              </audio>
            </div>
            <div
              v-else-if="renderMode === 'midia'"
              :style="
                item.dsc_tipo_midia_colaboracao === 'image'
                  ? ''
                  : 'display: grid; grid-template-columns: 1fr'
              "
              :class="
                item.dsc_tipo_midia_colaboracao === 'image'
                  ? 'd-flex align-center justify-center fundo-com-background'
                  : ''
              "
              :id="`${item.id_colaboracao}-wrapper`"
              style="z-index: 100000"
            >
              <img
                v-if="item.dsc_tipo_midia_colaboracao === 'image'"
                :id="`${item.id_colaboracao}`"
                :src="item.url_midia_colaboracao"
                :style="
                  isFullScreen
                    ? `max-width: ${
                        (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) /
                        100
                      }px;
                                                    min-width: ${
                                                      (percentScreenDim.fullScreenMinWidth *
                                                        screenDimensions.width) /
                                                      100
                                                    }px;
                                                    max-height: ${
                                                      (percentScreenDim.fullScreenMaxHeight *
                                                        screenDimensions.height) /
                                                      100
                                                    }px;
                                                    min-height: ${
                                                      (percentScreenDim.fullScreenMinHeight *
                                                        screenDimensions.height) /
                                                      100
                                                    }px;`
                    : `max-width: ${
                        (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                      }px;                                                  
                                                    max-height: ${
                                                      (percentScreenDim.maxHeight *
                                                        screenDimensions.height) /
                                                        100 -
                                                      50
                                                    }px`
                "
              />
              <video
                v-else-if="item.dsc_tipo_midia_colaboracao === 'video'"
                autoplay
                :id="`${item.id_colaboracao}`"
                :key="item.url_midia_colaboracao"
                style="justify-self: center; z-index: 100000 !important"
                :style="
                  isFullScreen
                    ? `max-height: ${
                        (percentScreenDim.fullScreenMaxHeight * screenDimensions.height) /
                        100
                      }px; 
                                    max-width: ${
                                      (percentScreenDim.fullScreenMaxWidth *
                                        screenDimensions.width) /
                                      100
                                    }px;`
                    : `max-width: ${
                        (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                      }px;
                                    max-height: ${
                                      (percentScreenDim.maxHeight *
                                        screenDimensions.height) /
                                        100 -
                                      50
                                    }px`
                "
              >
                <source :src="item.url_midia_colaboracao" />
              </video>
            </div>
            <div
              v-else-if="renderMode === 'midia_texto_fullscreen'"
              :style="
                item.dsc_tipo_midia_colaboracao === 'image' &&
                midiaOrientation === 'horizontal'
                  ? ''
                  : item.dsc_tipo_midia_colaboracao !== 'image' &&
                    midiaOrientation === 'horizontal'
                  ? 'display: grid; grid-template-columns: 1fr;'
                  : item.dsc_tipo_midia_colaboracao !== 'image'
                  ? 'display: grid; grid-template-columns: 1fr;'
                  : ''
              "
              :class="
                item.dsc_tipo_midia_colaboracao === 'image' &&
                midiaOrientation === 'horizontal'
                  ? 'd-flex align-center pa-2'
                  : item.dsc_tipo_midia_colaboracao === 'video' &&
                    midiaOrientation === 'horizontal'
                  ? 'pa-2'
                  : item.dsc_tipo_midia_colaboracao === 'video' &&
                    midiaOrientation === 'vertical'
                  ? ''
                  : ''
              "
              :id="`${item.id_colaboracao}-wrapper`"
              class="fundo-com-background"
            >
              <div
                v-if="midiaOrientation && midiaOrientation === 'horizontal'"
                class="d-flex flex-column"
              >
                <img
                  v-if="item.dsc_tipo_midia_colaboracao === 'image'"
                  :id="`${item.id_colaboracao}`"
                  :src="item.url_midia_colaboracao"
                  :style="
                    isFullScreen
                      ? `max-width: ${
                          (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) /
                          100
                        }px;
                                                        max-height: ${
                                                          (percentScreenDim.fullScreenMaxHeight *
                                                            screenDimensions.height) /
                                                          100
                                                        }px;
                                                        min-height: ${
                                                          (percentScreenDim.fullScreenMinHeight *
                                                            screenDimensions.height) /
                                                          100
                                                        }px;`
                      : `max-width: ${
                          (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                        }px; 
                                                        max-height: ${
                                                          (percentScreenDim.maxHeight *
                                                            screenDimensions.height) /
                                                            100 -
                                                          50
                                                        }px`
                  "
                />
                <video
                  v-if="item.dsc_tipo_midia_colaboracao === 'video'"
                  autoplay
                  :id="`${item.id_colaboracao}`"
                  :key="item.url_midia_colaboracao"
                  style="justify-self: center; z-index: 10000 !important"
                  :style="
                    isFullScreen
                      ? `max-height: ${
                          (percentScreenDim.fullScreenMaxHeight *
                            screenDimensions.height) /
                          100
                        }px; 
                                                        max-width: ${
                                                          (percentScreenDim.fullScreenMaxWidth *
                                                            screenDimensions.width) /
                                                          100
                                                        }px`
                      : `max-width: ${
                          (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                        }px; 
                                                        max-height: ${
                                                          (percentScreenDim.maxHeight *
                                                            screenDimensions.height) /
                                                            100 -
                                                          50
                                                        }px`
                  "
                >
                  <source :src="item.url_midia_colaboracao" />
                </video>
                <div
                  v-html="item.dsc_texto_colaboracao"
                  class="pt-5 px-3 py-3 font-weight-normal text-uppercase"
                  style="color: rgb(255, 255, 255); font-family: 'Gobold Thin'"
                  :style="{
                    lineHeight: lineHeightFullScreen,
                    fontSize: bodyTextSizeFullSreen,
                    wordBreak: 'break-word',
                  }"
                ></div>
              </div>
              <div
                v-else-if="midiaOrientation && midiaOrientation === 'vertical'"
                class="d-flex align-center justify-center"
              >
                <div class="pa-2 d-flex" style="background-color: #381973">
                  <img
                    v-if="item.dsc_tipo_midia_colaboracao === 'image'"
                    :src="item.url_midia_colaboracao"
                    :id="`${item.id_colaboracao}`"
                    :style="
                      isFullScreen
                        ? `max-width: ${
                            (percentScreenDim.fullScreenMaxWidth *
                              screenDimensions.width) /
                            100
                          }px;
                                                            max-height: ${
                                                              (percentScreenDim.fullScreenMaxHeight +
                                                                10 *
                                                                  screenDimensions.height) /
                                                              100
                                                            }px;
                                                            min-height: ${
                                                              (percentScreenDim.fullScreenMinHeight *
                                                                screenDimensions.height) /
                                                              100
                                                            }px;`
                        : `max-width: ${
                            (percentScreenDim.maxWidth * screenDimensions.width) / 100 -
                            20
                          }px; 
                                                            max-height: ${
                                                              (percentScreenDim.maxHeight *
                                                                screenDimensions.height) /
                                                                100 -
                                                              50
                                                            }px`
                    "
                  />
                  <video
                    v-if="item.dsc_tipo_midia_colaboracao === 'video'"
                    autoplay
                    :id="`${item.id_colaboracao}`"
                    :key="item.url_midia_colaboracao"
                    style="justify-self: center; z-index: 10000 !important"
                    :style="
                      isFullScreen
                        ? `max-height: ${
                            (percentScreenDim.fullScreenMaxHeight *
                              screenDimensions.height) /
                            100
                          }px; 
                                                            max-width: ${
                                                              (percentScreenDim.fullScreenMaxWidth *
                                                                screenDimensions.width) /
                                                              100
                                                            }px`
                        : `max-width: ${
                            (percentScreenDim.maxWidth * screenDimensions.width) / 100 -
                            20
                          }px; 
                                                            max-height: ${
                                                              (percentScreenDim.maxHeight *
                                                                screenDimensions.height) /
                                                                100 -
                                                              50
                                                            }px`
                    "
                  >
                    <source :src="item.url_midia_colaboracao" />
                  </video>
                  <div
                    v-html="item.dsc_texto_colaboracao"
                    class="pt-5 px-3 py-3 font-weight-normal text-uppercase"
                    style="color: rgb(255, 255, 255)"
                    :id="`${item.id_colaboracao}-text-div`"
                    :style="{
                      lineHeight: lineHeightFullScreen,
                      fontSize: bodyTextSizeFullSreen,
                      wordBreak: 'break-word',
                    }"
                  ></div>
                </div>
              </div>
            </div>
            <div
              v-else-if="renderMode === 'midia_texto'"
              :style="
                item.dsc_tipo_midia_colaboracao === 'image' &&
                midiaOrientation === 'horizontal'
                  ? ''
                  : item.dsc_tipo_midia_colaboracao !== 'image' &&
                    midiaOrientation === 'horizontal'
                  ? 'display: grid; grid-template-columns: 1fr;'
                  : item.dsc_tipo_midia_colaboracao !== 'image'
                  ? 'display: grid; grid-template-columns: 1fr;'
                  : ''
              "
              :class="
                item.dsc_tipo_midia_colaboracao === 'image' &&
                midiaOrientation === 'horizontal'
                  ? 'd-flex align-center pa-2'
                  : item.dsc_tipo_midia_colaboracao === 'video' &&
                    midiaOrientation === 'horizontal'
                  ? 'pa-2'
                  : ''
              "
              :id="`${item.id_colaboracao}-wrapper`"
              class="fundo-com-background"
            >
              <div
                v-if="midiaOrientation && midiaOrientation === 'horizontal'"
                class="d-flex flex-column"
                style="z-index: 10"
                :id="`${item.id_colaboracao}-midia-wrapper`"
              >
                <img
                  v-if="item.dsc_tipo_midia_colaboracao === 'image'"
                  :id="`${item.id_colaboracao}`"
                  :src="item.url_midia_colaboracao"
                  :style="
                    isFullScreen
                      ? `max-width: ${
                          (percentScreenDim.fullScreenMaxWidth * screenDimensions.width) /
                          100
                        }px;
                                                        min-width: ${
                                                          (percentScreenDim.fullScreenMinWidth *
                                                            screenDimensions.width) /
                                                          100
                                                        }px;
                                                        max-height: ${
                                                          (percentScreenDim.fullScreenMaxHeight *
                                                            screenDimensions.height) /
                                                          100
                                                        }px;
                                                        min-height: ${
                                                          (percentScreenDim.fullScreenMinHeight *
                                                            screenDimensions.height) /
                                                          100
                                                        }px;`
                      : `max-width: ${
                          (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                        }px;                                                      
                                                        max-height: ${
                                                          (percentScreenDim.maxHeight *
                                                            screenDimensions.height) /
                                                            100 -
                                                          50
                                                        }px`
                  "
                />
                <video
                  v-else-if="item.dsc_tipo_midia_colaboracao === 'video'"
                  autoplay
                  :id="`${item.id_colaboracao}`"
                  :key="item.url_midia_colaboracao"
                  style="justify-self: center; z-index: 10000 !important"
                  :style="
                    isFullScreen
                      ? `max-height: ${
                          (percentScreenDim.fullScreenMaxHeight *
                            screenDimensions.height) /
                          100
                        }px; 
                                                        max-width: ${
                                                          (percentScreenDim.fullScreenMaxWidth *
                                                            screenDimensions.width) /
                                                          100
                                                        }px`
                      : `max-width: ${
                          (percentScreenDim.maxWidth * screenDimensions.width) / 100 - 20
                        }px; 
                                                        max-height: ${
                                                          (percentScreenDim.maxHeight *
                                                            screenDimensions.height) /
                                                            100 -
                                                          50
                                                        }px`
                  "
                >
                  <source :src="item.url_midia_colaboracao" />
                </video>
                <div
                  v-html="item.dsc_texto_colaboracao"
                  class="px-3 py-3 font-weight-normal text-uppercase"
                  style="color: rgb(255, 255, 255); font-family: 'Gobold Thin'"
                  :style="{
                    lineHeight: lineHeight,
                    fontSize: bodyTextSize,
                    wordBreak: 'break-word',
                  }"
                ></div>
              </div>
              <div
                v-else-if="midiaOrientation && midiaOrientation === 'vertical'"
                class="d-flex"
              >
                <div
                  class="d-flex flex-column align-self-end"
                  style="
                    z-index: 1;
                    background-color: rgb(56, 25, 115);
                    width: 700px;
                    min-height: 160px;
                    max-height: 160px;
                    position: relative;
                  "
                  :style="`max-width: ${(33.5 * screenDimensions.width) / 100}px`"
                  :id="`${item.id_colaboracao}-text-div`"
                >
                  <header
                    v-if="
                      !hideUserInfo &&
                      item.url_midia_colaboracao &&
                      item.dsc_texto_colaboracao &&
                      midiaOrientation === 'vertical'
                    "
                    class="d-flex flex-wrap-1 px-2 mt-n4 ml-n2 header-vertical"
                  >
                    <div class="d-flex align-center">
                      <span
                        class="text-uppercase ml-8 py-1"
                        style="
                          color: rgb(255, 255, 255) !important;
                          font-size: 1.3rem;
                          text-shadow: 2px 3px 12px rgba(0, 0, 0, 0.95);
                          font-family: 'Gobold Thin';
                        "
                      >
                        {{
                          item.dsc_nome_colaborador && item.dsc_uf_colaborador
                            ? `${item.dsc_nome_colaborador} - ${item.dsc_uf_colaborador}`
                            : item.dsc_nome_colaborador && !item.dsc_uf_colaborador
                            ? `${item.dsc_nome_colaborador}`
                            : ""
                        }}
                      </span>
                    </div>
                  </header>
                  <div
                    v-html="item.dsc_texto_colaboracao"
                    class="px-3 py-3 font-weight-normal text-uppercase d-flex align-center align-self-center"
                    style="color: rgb(255, 255, 255); font-family: 'Gobold Thin'"
                    :style="{
                      lineHeight: lineHeight,
                      fontSize: bodyTextSize,
                      wordBreak: 'break-word',
                    }"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="d-flex align-center justify-center" style="width: 100%; height: 100%">
          <div class="spin-wrapper d-flex align-center justify-center">
            <span class="loader"></span>
          </div>
        </div>
      </template>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    posicaoCard: String,
    isFullScreen: Boolean,
    hideUserInfo: Boolean,
    flgExibirUf: Boolean,
  },
  data() {
    return {
      midiaOrientation: null,
      midiaDimension: {},
      divMidiaWrapperDimension: null,
      percentScreenDim: {
        // porcentagem da tela que a div irá ocupar
        maxWidth: 40,
        minWidth: 20,
        minHeight: 30,
        maxHeight: 70,
        fullScreenMaxWidth: 60,
        fullScreenMaxHeight: 80,
        fullScreenMinWidth: 20,
        fullScreenMinHeight: 60,
      },
      sectionDimensions: null,
      hasLoadedMidia: null,
      hasLoadedContentDiv: null,
      cardDimension: {},
    };
  },
  created() {
    if (this.item.url_midia_colaboracao) {
      this.getMidiaOrientation();
    }
  },
  mounted() {
    this.getSectionDimensions();
    this.getCardDimension();
  },
  computed: {
    renderMode() {
      if (
        this.item.dsc_tipo_midia_colaboracao &&
        this.item.dsc_tipo_midia_colaboracao === "audio"
      ) {
        return "audio";
      } else if (
        ["image", "video"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        (!this.item.dsc_texto_colaboracao || !this.item.flg_exibir_texto)
      ) {
        return "midia";
      } else if (
        ["image", "video"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        this.item.dsc_texto_colaboracao &&
        this.isFullScreen
      ) {
        return "midia_texto_fullscreen";
      } else if (
        ["image", "video"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        this.item.flg_exibir_texto &&
        this.item.dsc_texto_colaboracao &&
        !this.isFullScreen
      ) {
        return "midia_texto";
      } else if (
        this.item.dsc_texto_colaboracao &&
        this.isFullScreen &&
        !this.url_midia_colaboracao
      ) {
        return "texto_fullscreen";
      }
      return "text";
    },
    bodyTextSize() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      let size =
        (numChars > 0) & (numChars <= 40)
          ? "2.1rem"
          : numChars > 40 && numChars <= 80
          ? "2rem"
          : numChars > 80 && numChars <= 120
          ? "1.8rem"
          : numChars > 120 && numChars <= 160
          ? "1.6rem"
          : numChars > 160 && numChars <= 200
          ? "1.3rem"
          : numChars > 200 && numChars <= 240
          ? "1.3rem"
          : numChars > 240 && numChars <= 280
          ? "1.275rem"
          : "1.5rem";
      if (
        this.item.dsc_texto_colaboracao &&
        ["image", "video"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        this.midiaOrientation === "vertical"
      ) {
        size =
          (numChars > 0) & (numChars <= 40)
            ? "2rem"
            : numChars > 40 && numChars <= 80
            ? "1.7rem"
            : numChars > 80 && numChars <= 120
            ? "1.5rem"
            : numChars > 120 && numChars <= 160
            ? "1.3rem"
            : numChars > 160 && numChars <= 200
            ? "1.25rem"
            : numChars > 200 && numChars <= 240
            ? "1.15rem"
            : numChars > 240 && numChars <= 280
            ? "1rem"
            : "1.5rem";
      }
      return size;
    },
    lineHeight() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      let lineHeight =
        (numChars > 0) & (numChars <= 40)
          ? "2.7rem"
          : numChars > 40 && numChars <= 80
          ? "2.5rem"
          : numChars > 80 && numChars <= 120
          ? "2.4rem"
          : numChars > 120 && numChars <= 160
          ? "2.3rem"
          : numChars > 160 && numChars <= 200
          ? "2.1rem"
          : numChars > 200 && numChars <= 240
          ? "2rem"
          : numChars > 240 && numChars <= 280
          ? "1.9rem"
          : "1.5rem";

      if (
        this.item.dsc_texto_colaboracao &&
        ["image", "video"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        this.midiaOrientation === "vertical"
      ) {
        lineHeight =
          (numChars > 0) & (numChars <= 40)
            ? "2.5rem"
            : numChars > 40 && numChars <= 80
            ? "2rem"
            : numChars > 80 && numChars <= 120
            ? "1.8rem"
            : numChars > 120 && numChars <= 160
            ? "1.7rem"
            : numChars > 160 && numChars <= 200
            ? "1.6rem"
            : numChars > 200 && numChars <= 240
            ? "1.55rem"
            : numChars > 240 && numChars <= 280
            ? "1.4rem"
            : "1.5rem";
      }

      return lineHeight;
    },
    bodyTextSizeFullSreen() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const size =
        (numChars > 0) & (numChars <= 40)
          ? "3rem"
          : numChars > 40 && numChars <= 80
          ? "2.7rem"
          : numChars > 80 && numChars <= 120
          ? "2.5rem"
          : numChars > 120 && numChars <= 160
          ? "2.3rem"
          : numChars > 160 && numChars <= 200
          ? "2rem"
          : numChars > 200 && numChars <= 240
          ? "1.9rem"
          : numChars > 240 && numChars <= 280
          ? "1.8rem"
          : "1.5rem";
      return size;
    },
    lineHeightFullScreen() {
      const numChars = this.item.dsc_texto_colaboracao.trim().length;
      const lineHeight =
        (numChars > 0) & (numChars <= 40)
          ? "4rem"
          : numChars > 40 && numChars <= 80
          ? "3.8rem"
          : numChars > 80 && numChars <= 120
          ? "3.3rem"
          : numChars > 120 && numChars <= 160
          ? "3rem"
          : numChars > 160 && numChars <= 200
          ? "2.8rem"
          : numChars > 200 && numChars <= 240
          ? "2.6rem"
          : numChars > 240 && numChars <= 280
          ? "2.5rem"
          : "1.5rem";

      return lineHeight;
    },
    screenDimensions() {
      return {
        width: this.$vuetify.breakpoint.width,
        height: this.$vuetify.breakpoint.height,
      };
    },
    cardStyle() {
      let maxWidth, maxHeight, minWidth, minHeight;
      if (this.isFullScreen) {
        minWidth =
          (this.percentScreenDim.fullScreenMinWidth * this.screenDimensions.width) / 100; // 20% of screen width + 20px
        maxWidth =
          (this.percentScreenDim.fullScreenMaxWidth * this.screenDimensions.width) / 100 +
          20; // 60% of screen width + 20px
        minHeight =
          (this.percentScreenDim.fullScreenMinHeight * this.screenDimensions.height) /
          100; // 60% of screen height + 50px
        maxHeight =
          (this.percentScreenDim.fullScreenMaxHeight * this.screenDimensions.height) /
            100 +
          50; // 80% of screen height + 50px
        if (this.renderMode === "texto_fullscreen") {
          minWidth =
            (this.percentScreenDim.fullScreenMinWidth -
              10 * this.screenDimensions.width) /
            100;
          minHeight =
            (this.percentScreenDim.fullScreenMinHeight -
              30 * this.screenDimensions.height) /
            100;
        }
        const fullScreenStyle = `justify-self: center; max-width: ${maxWidth}px !important; max-height: ${maxHeight}px !important;
                                         min-width: ${minWidth}px !important; min-height: ${minHeight}px !important;`;
        return fullScreenStyle;
      }
      const position =
        this.posicaoCard === "esquerda" && !this.item.url_midia_colaboracao
          ? "margin-left: 100px; justify-self: flex-start"
          : this.posicaoCard === "centro"
          ? "justify-self: center"
          : this.posicaoCard === "direita" && !this.item.url_midia_colaboracao
          ? "margin-right: 40px; justify-self: flex-end"
          : this.posicaoCard === "direita" && this.item.url_midia_colaboracao
          ? "margin-right: 60px; justify-self: flex-start"
          : this.posicaoCard === "esquerda" && this.item.url_midia_colaboracao
          ? "margin-left: 120px; justify-self: flex-start"
          : "";

      // regras para visualização normal, sem modo tela cheia
      maxWidth = (this.percentScreenDim.maxWidth * this.screenDimensions.width) / 100; // 40% of screen width
      maxHeight = (this.percentScreenDim.maxHeight * this.screenDimensions.height) / 100; // 80% of screen height
      // const textMaxWidth = (33.5 * this.screenDimensions.width) / 100; // 40% of screen width
      // const textMaxHeight = (15.5 * this.screenDimensions.height) / 100; // 20% of screen height)
      const dimensions =
        ["video", "image"].includes(this.item.dsc_tipo_midia_colaboracao) &&
        !this.item.dsc_texto_colaboracao
          ? `max-width: ${maxWidth}px; max-height: ${maxHeight}px !important;`
          : this.item.url_midia_colaboracao &&
            this.item.dsc_texto_colaboracao &&
            this.midiaOrientation === "horizontal"
          ? `max-width: ${maxWidth}px; max-height: ${maxHeight}px !important;`
          : this.item.url_midia_colaboracao &&
            this.item.dsc_texto_colaboracao &&
            this.midiaOrientation === "vertical"
          ? `max-width: auto !important; max-height: ${maxHeight}px !important;`
          : `width: 700px; min-heig1ht: 160px; max-height: 160px;`;

      const array = position.split(";").concat(dimensions.split(";"));
      return array.filter((item) => item).join(";");
    },
    outerBorderStyle() {
      if (!this.sectionDimensions) {
        return null;
      }
      let styles;

      if (
        this.renderMode === "midia_texto_fullscreen" &&
        this.midiaOrientation === "vertical"
      ) {
        styles = {
          width: `${this.cardDimension.width + 4}px`,
          height: `${this.cardDimension.height - 20}px`,
        };
        if (this.item.dsc_tipo_midia_colaboracao === "video") {
          styles = {
            width: `${this.cardDimension.width + 4}px`,
            height: `${this.cardDimension.height + 4}px`,
          };
        }
      } else if (
        this.renderMode === "midia_texto_fullscreen" &&
        this.midiaOrientation === "horizontal"
      ) {
        styles = {
          width: `${this.cardDimension.width + 4}px`,
          height: `${this.cardDimension.height - 16}px`,
        };
      } else if (
        this.isFullScreen &&
        this.renderMode === "midia" &&
        this.midiaOrientation === "vertical"
      ) {
        styles = {
          width: `${this.cardDimension.width + 4}px`,
          height: `${this.cardDimension.height - 16}px`,
        };
      } else if (
        this.isFullScreen &&
        this.renderMode === "midia" &&
        this.midiaOrientation === "horizontal"
      ) {
        styles = {
          width: `${this.cardDimension.width + 4}px`,
          height: `${this.cardDimension.height - 14}px`,
        };
      } else if (
        !this.isFullScreen &&
        this.renderMode === "midia" &&
        this.midiaOrientation === "vertical"
      ) {
        styles = {
          width: `${this.cardDimension.width}px`,
          height: `${this.cardDimension.height - 20}px`,
        };
      } else if (
        !this.isFullScreen &&
        this.renderMode === "midia" &&
        this.midiaOrientation === "horizontal"
      ) {
        styles = {
          width: `${this.cardDimension.width + 8}px`,
          height: `${this.cardDimension.height - 20}px`,
        };
      } else if (
        !this.isFullScreen &&
        this.renderMode === "midia_texto" &&
        this.midiaOrientation === "vertical" &&
        this.item.dsc_texto_colaboracao
      ) {
        styles = {
          width: `${this.sectionDimensions.width + 8}px`,
          height: `${this.sectionDimensions.height}px`,
        };
      } else {
        styles = {
          width: `${this.sectionDimensions.width + 8}px`,
          height: `${this.sectionDimensions.height + 10}px`,
        };
      }

      // if (this.item.url_midia_colaboracao && this.midiaOrientation === 'vertical'
      //     && !this.isFullScreen && this.item.dsc_texto_colaboracao && this.item.flg_exibir_texto) {
      //     styles['bottom'] = '40px';
      // }
      return styles;
    },
    innerBorderStyle() {
      if (!this.sectionDimensions) {
        return null;
      }

      let styles;

      if (
        this.renderMode === "midia_texto_fullscreen" &&
        this.midiaOrientation === "vertical"
      ) {
        styles = {
          width: `${this.cardDimension.width + 4}px`,
          height: `${this.cardDimension.height - 20}px`,
        };
        if (this.item.dsc_tipo_midia_colaboracao === "video") {
          styles = {
            width: `${this.cardDimension.width + 4}px`,
            height: `${this.cardDimension.height + 8}px`,
          };
        }
      } else if (
        this.renderMode === "midia_texto_fullscreen" &&
        this.midiaOrientation === "horizontal"
      ) {
        styles = {
          width: `${this.cardDimension.width + 4}px`,
          height: `${this.cardDimension.height - 12}px`,
        };
      } else if (
        this.isFullScreen &&
        this.renderMode === "midia" &&
        this.midiaOrientation === "vertical"
      ) {
        styles = {
          width: `${this.cardDimension.width + 4}px`,
          height: `${this.cardDimension.height - 16}px`,
        };
      } else if (
        this.isFullScreen &&
        this.renderMode === "midia" &&
        this.midiaOrientation === "horizontal"
      ) {
        styles = {
          width: `${this.cardDimension.width + 4}px`,
          height: `${this.cardDimension.height - 10}px`,
        };
      } else if (
        !this.isFullScreen &&
        this.renderMode === "midia" &&
        this.midiaOrientation === "vertical"
      ) {
        styles = {
          width: `${this.cardDimension.width}px`,
          height: `${this.cardDimension.height - 62}px`,
        };
      } else if (
        !this.isFullScreen &&
        this.renderMode === "midia" &&
        this.midiaOrientation === "horizontal"
      ) {
        styles = {
          width: `${this.cardDimension.width + 6}px`,
          height: `${this.cardDimension.height - 60}px`,
        };
      } else if (
        !this.isFullScreen &&
        this.renderMode === "midia_texto" &&
        this.midiaOrientation === "vertical" &&
        this.item.dsc_texto_colaboracao
      ) {
        styles = {
          width: `${this.sectionDimensions.width + 8}px`,
          height: `${this.sectionDimensions.height - 5}px`,
        };
      } else {
        styles = {
          width: `${this.sectionDimensions.width + 8}px`,
          height: `${this.sectionDimensions.height + 10}px`,
        };
      }

      return styles;
    },
    outerBorderImgStyle() {
      if (!this.divMidiaWrapperDimension) {
        return null;
      }
      let styles = {
        width: `${this.divMidiaWrapperDimension.width + 8}px`,
        height: `${this.divMidiaWrapperDimension.height + 2}px`,
      };
      // if(this.item.url_midia_colaboracao && this.midiaOrientation === 'vertical' && this.item.dsc_texto_colaboracao && !this.isFullScreen) {
      //     styles['bottom'] = '40px';
      // }
      return styles;
    },
    innerBorderImgStyle() {
      if (!this.divMidiaWrapperDimension) {
        return null;
      }
      let styles = {
        width: `${this.divMidiaWrapperDimension.width + 6}px`,
        height: `${this.divMidiaWrapperDimension.height + 0}px`,
      };
      return styles;
    },
    hasLoadedProperties() {
      if (
        !this.item.url_midia_colaboracao &&
        this.screenDimensions &&
        this.cardStyle &&
        this.sectionDimensions
      ) {
        return true;
      } else if (
        this.item.url_midia_colaboracao &&
        this.midiaOrientation &&
        this.sectionDimensions &&
        this.innerBorderStyle &&
        this.outerBorderStyle &&
        this.screenDimensions &&
        this.cardStyle
      ) {
        return true;
      }
      return true;
    },
  },
  methods: {
    getCardDimension() {
      const elementDimension = document.querySelector(".card");
      this.cardDimension = {
        width: elementDimension.offsetWidth,
        height: elementDimension.offsetHeight,
      };
    },
    getSectionDimensions() {
      let sectionElement;
      if (
        ["audio"].includes(this.item.dsc_tipo_midia_colaboracao) ||
        !this.item.url_midia_colaboracao
      ) {
        sectionElement = document.querySelector(".card");
      } else if (
        this.item.url_midia_colaboracao &&
        this.midiaOrientation === "vertical" &&
        this.item.dsc_texto_colaboracao &&
        this.item.flg_exibir_texto &&
        !this.isFullScreen
      ) {
        sectionElement = document.getElementById(`${this.item.id_colaboracao}-text-div`);
      } else {
        sectionElement = document.getElementById(`${this.item.id_colaboracao}-wrapper`);
      }
      if (sectionElement) {
        const width = sectionElement.offsetWidth;
        const height = sectionElement.offsetHeight;
        this.sectionDimensions = {
          width: width,
          height: height,
        };
      }
    },
    checkMidiaHasLoaded() {
      setTimeout(() => {
        const midiaElement = document.getElementById(`${this.item.id_colaboracao}`);
        if (
          this.midiaOrientation === "vertical" &&
          this.item.dsc_texto_colaboracao &&
          !this.hasLoadedContentDiv
        ) {
          const textElement = document.getElementById(
            `${this.item.id_colaboracao}-text-div`
          );
          if (textElement) {
            this.hasLoadedContentDiv = true;
          }
        }
        if (midiaElement) {
          this.hasLoadedMidia = true;
        } else {
          this.hasLoadedMidia = false;
          if (
            this.item.url_midia_colaboracao &&
            this.item.dsc_tipo_midia_colaboracao === "audio"
          ) {
            this.hasLoadedMidia = true;
          }
        }
        // this.hasLoadedMidia = false
      }, 100);
    },
    getDivMidiaWrapperDimension() {
      let midiaWrapperElement;
      if (
        this.item.url_midia_colaboracao &&
        this.item.dsc_tipo_midia_colaboracao === "video"
      ) {
        midiaWrapperElement = document.getElementById(
          `${this.item.id_colaboracao}-midia-wrapper`
        );
      } else if (
        this.item.url_midia_colaboracao &&
        this.item.dsc_tipo_midia_colaboracao === "image"
      ) {
        midiaWrapperElement = document.getElementById(
          `${this.item.id_colaboracao}-midia-wrapper`
        );
      }
      if (midiaWrapperElement) {
        this.divMidiaWrapperDimension = {
          width: midiaWrapperElement.offsetWidth,
          height: midiaWrapperElement.offsetHeight,
        };
      }
    },
    getMidiaOrientation() {
      if (this.item.url_midia_colaboracao) {
        if (this.item.dsc_tipo_midia_colaboracao === "image") {
          const image = new Image();
          image.src = this.item.url_midia_colaboracao;
          image.onload = () => {
            this.midiaDimension = { width: image.width, height: image.height };
            this.midiaOrientation =
              image.height > image.width ? "vertical" : "horizontal";
          };
        } else if (this.item.dsc_tipo_midia_colaboracao === "video") {
          const createdVideoElement = document.createElement("video");
          createdVideoElement.src = this.item.url_midia_colaboracao;
          createdVideoElement.style.visibility = "hidden";
          document.body.appendChild(createdVideoElement);
          createdVideoElement.addEventListener("loadedmetadata", () => {
            this.midiaDimension = {
              width: createdVideoElement.videoWidth,
              height: createdVideoElement.videoHeight,
            };
            this.midiaOrientation =
              createdVideoElement.videoHeight > createdVideoElement.videoWidth
                ? "vertical"
                : "horizontal";
            document.body.removeChild(createdVideoElement);
          });
        }
      }
    },
  },
  watch: {
    item: function (newValue) {
      if (newValue.url_midia_colaboracao) {
        this.getMidiaOrientation();
        this.getDivMidiaWrapperDimension();
        this.getSectionDimensions();
        this.checkMidiaHasLoaded();

        this.getCardDimension();
      } else {
        this.getSectionDimensions();
        this.getCardDimension();
        this.hasLoadedMidia = true;
      }
    },
    cardStyle() {
      this.getMidiaOrientation();
      this.getDivMidiaWrapperDimension();
      this.getSectionDimensions();
      this.getCardDimension();
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "Gobold";
  src: url("@/assets/Gobold_Regular.otf") format("opentype");
}

@font-face {
  font-family: "Gobold Thin";
  src: url("@/assets/Gobold_Thin.otf") format("opentype");
}

.fundo-com-background {
  background-color: #381973;
}

.header-vertical {
  width: calc(100% + 8px);
}
.borda-vertical {
  padding: 8px 8px 0px 0px;
  border: 2px solid #ff9a43;
  position: relative;
}

.borda-vertical::before {
  content: "";
  position: absolute;
  margin-left: -8px;
  margin-top: 0px;
  display: block;
  width: calc(100% + 6px);
  height: 100%;
  border-top: 2px solid #43dceb;
  border-right: 2px solid #43dceb;
  border-bottom: 2px solid #43dceb;
}

.borda {
  padding: 8px 8px 0px 0px;
  border: 2px solid #ff9a43;
  position: relative;
}
.borda::before {
  content: "";
  position: absolute;
  margin-left: -8px;
  margin-top: 0px;
  display: block;
  width: calc(100% + 6px);
  height: 100%;
  border: 2px solid #43dceb;
}

header {
  z-index: 10;
  width: 100%;
  background: rgb(146, 121, 217);
  background: -moz-linear-gradient(
    90deg,
    rgba(146, 121, 217, 1) 0%,
    rgba(250, 91, 189, 1) 50%,
    rgba(255, 154, 67, 1) 100%
  );
  background: -webkit-linear-gradient(
    90deg,
    rgba(146, 121, 217, 1) 0%,
    rgba(250, 91, 189, 1) 50%,
    rgba(255, 154, 67, 1) 100%
  );
  background: linear-gradient(
    90deg,
    rgba(146, 121, 217, 1) 0%,
    rgba(250, 91, 189, 1) 50%,
    rgba(255, 154, 67, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#9279d9", endColorstr="#ff9a43", GradientType=1);
}

section {
  width: 100%;
  position: relative;
  bottom: 20px;
}

.card {
  position: relative;
}

.outer-border {
  z-index: 2;
  //   bottom: 20px;
  border: 2px solid #ff9a43;

  &.card {
    position: absolute !important;
  }

  &.card-not-fullscreen {
    position: absolute !important;
    top: 0;
    left: 0.5px;
  }

  &.txt {
    position: absolute !important;
    top: 2px !important;
    left: -1px !important;
  }

  &.img {
    position: absolute !important;
    top: -3px !important;
    left: -1px !important;
    z-index: 9999 !important;
  }
}

.inner-border {
  border: 2px solid #43dceb;
  top: 2px;
  left: -6px;
  position: relative;

  &.card {
    position: absolute !important;
  }

  &.card-not-fullscreen {
    z-index: 99999;
    position: absolute !important;
    top: 43px;
    left: -1.5px;
  }

  &.txt {
    position: absolute !important;
    top: 8px !important;
    left: -3px !important;
  }

  &.img {
    position: absolute !important;
    top: 0 !important;
    left: -3px !important;
    z-index: 9998 !important;
  }
}

.spin-wrapper {
  width: 100%;
  height: 100%;
}

.loader {
  display: inline-block;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  position: relative;
  animation: rotate 1s linear infinite;
}

.loader::before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  inset: 0px;
  border-radius: 50%;
  border: 5px solid #fff;
  animation: prixClipFix 2s linear infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes prixClipFix {
  0% {
    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
  }

  25% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
  }

  50% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
  }

  75% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
  }

  100% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
  }
}
</style>
